import {
  type CreateDefinitionDto,
  CreateDefinitionDtoTypeEnum,
  type CreateDefinitionParameterDto,
  CreateDefinitionParameterDtoTypeEnum,
  type CreateDefinitionParameterValueDto,
  CreateDefinitionParameterValueDtoTypeEnum,
  type CreateDefinitionParameterValueSetDto,
  CreateDefinitionParameterValueSetDtoTypeEnum,
  CreateEvaluationQuantityUsageDtoTypeEnum,
  CreateSetupQuantityUsageDtoTypeEnum,
  type CreateUpdateNumericQuantityDto,
  CreateUpdateNumericQuantityDtoTypeEnum,
  type DefinitionDto,
  type DefinitionParameterDto,
  type DefinitionParameterValueDto,
  type DefinitionParameterValueSetDto,
  type NumericQuantityDto,
  QuantityValueType,
  type ReferencedEntityGuidDto,
  ReferencedEntityGuidDtoTypeEnum,
} from '@/api/generator';
import { NIL } from 'uuid';

const nullifiedId = (id: string) => (id === NIL ? null : id);

export function toCreateDefinition(definition: DefinitionDto): CreateDefinitionDto {
  return {
    ...definition,
    valueType: definition.valueType ?? QuantityValueType.FloatingPoint,
    definitionParameters: definition.definitionParameters?.map(toCreateDefinitionParameterDto),
    definitionParameterValueSets: definition.definitionParameterValueSets?.map(
      toCreateDefinitionParameterValueSetDto,
    ),
    $type:
      CreateDefinitionDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDefinitionParameterValueSetDto(
  dto: DefinitionParameterValueSetDto,
): CreateDefinitionParameterValueSetDto {
  return {
    ...dto,
    id: nullifiedId(dto.id),
    values: dto.values?.map(toCreateDefinitionParameterValueDto),
    $type:
      CreateDefinitionParameterValueSetDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterValueSetDtoPtwPtw100AppZeroApplicationShared,
  };
}
export function toReferencedEntityGuidDto(dto: { id: string }): ReferencedEntityGuidDto {
  return {
    ...dto,
    $type:
      ReferencedEntityGuidDtoTypeEnum.PtwPtw100AppZeroApplicationSharedCommonDtoReferencedEntityGuidDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDefinitionParameterValueDto(
  dto: DefinitionParameterValueDto,
): CreateDefinitionParameterValueDto {
  return {
    ...dto,
    id: nullifiedId(dto.id),
    $type:
      CreateDefinitionParameterValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterValueDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDefinitionParameterDto(dto: DefinitionParameterDto): CreateDefinitionParameterDto {
  return {
    ...dto,
    id: nullifiedId(dto.id),
    valueType: dto.valueType ?? QuantityValueType.FloatingPoint,
    $type:
      CreateDefinitionParameterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionParameterDtoPtwPtw100AppZeroApplicationShared,
  };
}
function toCreateDefinitionDto(dto: DefinitionDto): CreateDefinitionDto {
  return {
    ...dto,
    id: nullifiedId(dto.id),
    definitionParameters: dto.definitionParameters?.map(toCreateDefinitionParameterDto),
    definitionParameterValueSets: dto.definitionParameterValueSets?.map(
      toCreateDefinitionParameterValueSetDto,
    ),
    $type:
      CreateDefinitionDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateUpdateNumericQuantityDto(
  dto: NumericQuantityDto,
): CreateUpdateNumericQuantityDto {
  return {
    ...dto,
    quantityUsageType: dto.quantityUsageType ?? undefined,
    setupUsage: {
      ...dto.setupUsage,
      $type:
        CreateSetupQuantityUsageDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateSetupQuantityUsageDtoPtwPtw100AppZeroApplicationShared,
    },
    evaluationUsage: {
      ...dto.evaluationUsage,
      definitions: dto.evaluationUsage?.definitions?.map(toCreateDefinitionDto),
      $type:
        CreateEvaluationQuantityUsageDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateEvaluationQuantityUsageDtoPtwPtw100AppZeroApplicationShared,
    },
    $type:
      CreateUpdateNumericQuantityDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateUpdateNumericQuantityDtoPtwPtw100AppZeroApplicationShared,
  };
}
